// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__D4Y7u","animate":"Item_animate__KgaWF","fadeIn":"Item_fadeIn__SEuho","background":"Item_background__NmDS4"};